import request from "./request";
import * as paths from "./paths";
import {cookiePopup, cookies} from "./paths";

class general {

    static getFooter = async (locale:any) => {
        return await request.get(`/api/footers?populate=deep&locale=${locale}`);
    };

    static getPages = async (locale:any) => {
        return await request.get(`/api/pages?populate[pages][populate]=*&locale=${locale}`);
    };

    static getItemIcon = async () => {
        return await request.get(`/api/pages?populate[pages][populate][item][populate]=icon`);
    };

    static getLogos = async () => {
        return await request.get(`${paths.logos}/?populate=*`);
    };

    static getHeaderLogos = async (locale:any) => {
        return await request.get(`${paths.headerLogo}/?populate=*&locale=${locale}`);
    };
    
    static getSections = async (locale:any) => {
        return await request.get(`${paths.section}/?populate=*&locale=${locale}`);
    };

    static getEntries = async (locale:any, id:any) => {
        return await request.get(`${paths.dataEntries}/?populate=deep,5&filters[page][id][$eq]=${id}&locale=${locale}`);
    };

    static getLibrary= async () => {
        return await request.get(`${paths.pdfLibraries}/?populate=deep,5`);
    };

    static sendMail = async (message: any) => {
        return await request.post(`${paths.sendEmail}`, message);
    };

    static getCookies = async (locale: any) => {
        return await request.get(`${paths.cookies}`);
    };

    static getCookiePopup = async (locale: any) => {
        return await request.get(`${paths.cookiePopup}`);
    };


    
    }

export { general };
